import React, { useState,useContext } from "react";
import { useForm } from 'react-hook-form';
import { AuthContext } from '../../context/AuthContext';
import "./ForgotPassword.scss";
import masterApi from "../../services/masterApi";
import logo from "../../assets/images/logo.png";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import workshop from "../../assets/images/workshop.png";
import ConfirmationModal from "../../components/confirmationModal/ConfirmationModal";
const ForgotPassword = () => {
  const { register, handleSubmit, getValues, formState: { errors },reset  } = useForm()
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [viewLoader, setViewLoader] = useState(false);
  const { handleLogout } = useContext(AuthContext);
  const [isModalVisible, setIsModalVisible] = useState(false); 
  const [data, setData] = useState(); 
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    setData(data);
    // setIsModalVisible(true);  
    setViewLoader(true)
    try {
      const response = await masterApi.forgotPassword({ data });
      //console.log(response);
      if (response?.data?.ok) { 
        toast.success("Password reset link sent successfully. Please check your mail again.", {
          autoClose: 1000, // 1 seconds
          onClose: () => {
            // setIsModalVisible(false);
            // reset ();
            onReset ();
          }          
        })          
        setSuccess("Success");
      } else {
        setViewLoader(false)
        setError(response?.response.data.message);
        toast.error(response?.response?.data?.message, {
          autoClose: 1000, // 1 seconds                    
        })
      }
    } catch (error) {
      setViewLoader(false)
      setError('Someting went wrong!')
      console.error('Login failed:', error.message);
    }   
  }
  const onReset  = () =>{
    navigate('../login')
  }
  
  // const handleConfirmClick = async() => {
  //   setViewLoader(true)
  //   try {
  //     const response = await masterApi.forgotPassword({ data });
  //     //console.log(response);
  //     if (response?.data?.ok) { 
  //       toast.success("Password reset link sent successfully. Please check your mail again.", {
  //         autoClose: 1000, // 1 seconds
  //         onClose: () => {
  //           setIsModalVisible(false);
  //           reset ();
  //         }          
  //       })          
  //       setSuccess("Success");
  //     } else {
  //       setViewLoader(false)
  //       setError(response?.response.data.message);
  //       toast.error(response?.response?.data?.message, {
  //         autoClose: 1000, // 1 seconds                    
  //       })
  //     }
  //   } catch (error) {
  //     setViewLoader(false)
  //     setError('Someting went wrong!')
  //     console.error('Login failed:', error.message);
  //   }  
  // };
  // const closeModal = () => {
  //   setIsModalVisible(false);
  //   setData(null);
  // };


  return (
    <div className="main-login-area">
      <div className="login-box">
        <div className="box-left">
          <div className="login-content-area">
            <div className="logo-area">
              <div className="logo-box">
                <div className="logo-img">
                <img src={logo} alt="" />
                </div>
                <div className="logo-heading">Scheduler</div>
              </div>
            </div>
            <div className="login-input-area">
            <h2 className="heading space-between">Forgot Password</h2>
            <form className="login-form space-between" onSubmit={handleSubmit(onSubmit)}>
              
              <input {...register('email', { required: true })}
                className= {`input ${errors.email ? 'form-control required' : 'form-control'}`}
                type="text"
                placeholder="Email Id"
              />
               <div className="action-btn">
              <button className="cancel secondary-btn" onClick={onReset}>
                Cancel
              </button>
      
              <button className="save primary-btn" type="submit">              
                Submit
              </button>
              </div>
            </form>
          </div>
          </div>
        </div>
        <div className="box-right">
          <img src={workshop} alt="" />
        </div>
      </div>
      {<ToastContainer autoClose={1500} />}
      {/* {isModalVisible && (
        <ConfirmationModal
          show={isModalVisible}
          title="Forgot Password"
          message={`Are you sure proceed with  forgot password password ?`}
          onConfirm={handleConfirmClick} // Call to confirm deletion
          onCancel={closeModal} // Close modal if canceled
          confirmText="Yes, Proceed"
          cancelText="No, Cancel"
        />
      )} */}
    </div>
  );
};

export default ForgotPassword;
